import React from 'react';
import moment from 'moment';
import * as _ from 'lodash';
import {
  getNiceDayAndDateForMatchlist,
  getArenaName,
} from '../../utils/matches';
import { getMatchUrl } from '../../utils/routes';
import { useTicketConfig } from '../../hooks/ticket';

function MatchRowUpcoming({ match }) {
  const {
    homeTeamName,
    visitingTeamName,
    homeTeamScore,
    visitingTeamScore,
    startDate,
    homeTeamAbbrv,
    arenaName,
  } = match;

  const [ticketConfig] = useTicketConfig(homeTeamAbbrv);
  const ticketUrl = _.get(ticketConfig, 'ticketUrl', '');
  const isToday = moment().isSame(startDate, 'day');
  const title = !isToday ? getNiceDayAndDateForMatchlist(startDate) : `Idag`;

  return (
    <div className="col-12 px-4 py-2 data-container__row data-container__row--has-hover">
      <div className="row">
        <div className="col-12 col-md mb-2 mb-md-0">
          <p className="text-uppercase g-h6 mb-1 text-color-comp-gray-1">
            {title}
          </p>
          <a
            href={getMatchUrl(
              match.configSeasonStartYear,
              match.id,
              homeTeamName,
              visitingTeamName
            )}
            className="g-h5 mb-0 text-decoration-none text-color-primary-white"
          >
            {homeTeamName} - {visitingTeamName}
          </a>
        </div>
        <div className="col-12 col-md d-flex justify-content-center flex-column align-items-start align-items-md-end">
          <p className="text-uppercase g-h6 mb-1 text-color-comp-gray-1">
            {getArenaName(match)}
          </p>
          <div>
            <p className="g-h5 mb-0">{moment(startDate).format('HH:mm')}</p>
          </div>
        </div>
        {ticketUrl && (
          <div className="col d-none d-md-flex align-items-center justify-content-md-end">
            <a className="button button--primrary-yellow" href={ticketUrl}>
              KÖP BILJETT
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

export default MatchRowUpcoming;
